// veeValidationSetup.js
import { Validator } from 'vee-validate';
import { validationMessages } from './sif/validationMessages';
import { validationAttributes } from './sif/validationAttributes'; // optional friendly names
import { required, integer, max } from 'vee-validate/dist/rules.esm';

// Custom rules only — no Vue.use()
export function registerCustomVeeRules() {

    /*

    Validator.extend('required_if', {
        getMessage: field => `${field} is required`,
        validate(value, [otherValue]) {
            //console.log('required_if validate called with value:', value, 'otherFieldName:', otherFieldName);
            // `this` gives access to form data
            console.log('otherValue:', otherValue);
            



            // Require current field if other field is 1
            if (parseInt(otherValue) === 1) {
                ///console.log('Field is required because other field value is 1',value);
                return value !== undefined && value !== null && String(value).trim().length > 0;
            }

            // Otherwise optional
            return false;
        }
    });

    */






    // Extend the 'required' rule with a custom message
  Validator.extend('required', {
    ...required, // Spread existing rule properties (like the validator function itself)
    getMessage: field => ` ${validationAttributes[field]} ${ field in validationMessages.en.custom &&  Object.hasOwn(validationMessages.en.custom[field], 'required') ? validationMessages.en.custom[field].required : ' is required' }`,
  });

  Validator.extend('integer', {
    ...integer, // Spread existing rule properties (like the validator function itself)
    getMessage: field => ` ${validationAttributes[field]} ${ field in validationMessages.en.custom &&  Object.hasOwn(validationMessages.en.custom[field], 'integer') ? validationMessages.en.custom[field].integer : ' is must a number and in English numbers only' }`,
  });

  Validator.extend('max', {
    ...max, // Spread existing rule properties (like the validator function itself)
    getMessage: (field, params) => {
      //console.log('max params:', params);
      const maxValue = params[0];
      return `${validationAttributes[field]} ${ field in validationMessages.en.custom &&  Object.hasOwn(validationMessages.en.custom[field], 'max') ? validationMessages.en.custom[field].max : ` is must be less then ${maxValue}`}`;
    }
      
  });
   
  // Bangla letters only
  Validator.extend('bangla', {
    getMessage: field => `${field in validationMessages.en.custom ? validationMessages.en.custom[field].bangla : `${validationAttributes[field]} - Bangla letters only`}`,
    validate: value => /^[\u0980-\u09FF\s]+$/u.test(value)
  });

  // English letters, numbers and spaces only - no special characters
  Validator.extend('english', {
    getMessage: field => `${field in validationMessages.en.custom ? validationMessages.en.custom[field].english : `${validationAttributes[field]} - English letters only`}`,
    validate: value => /^[a-zA-Z\s]+$/u.test(value)
  });

  Validator.extend('english_numbers', {
    getMessage: field => `${field in validationMessages.en.custom ? validationMessages.en.custom[field].english : `${validationAttributes[field]} - English letters only and you can use comma, colon, dot , spaces, slash, hyphen, hash or numbers in case needed`}`,
    validate: value => /^[a-zA-Z0-9\s,:\.\-\/#]+$/u.test(value)
  });

  // No numbers
  Validator.extend('no_number', {
    getMessage: field => `${field in validationMessages.en.custom ? validationMessages.en.custom[field].no_number : `${validationAttributes[field]} - No numbers allowed`}`,
    validate: value => !/[\u09E6-\u09EF0-9]/u.test(value)
  });

  // Bangladesh mobile number
  Validator.extend('mobile', {
    getMessage: field => `${field in validationMessages.en.custom ? validationMessages.en.custom[field].mobile : `${validationAttributes[field]} - Invalid mobile number must be start with 013|014|015|016|017|018|019 and more 8 digits in English numbers only`}`,
    validate: value => /^(013|014|015|016|017|018|019)\d{8}$/.test(value)
  });
  
  Validator.extend('nid_brno', {
    getMessage: field => `${field in validationMessages.en.custom ? validationMessages.en.custom[field].nid_brno : `${validationAttributes[field]} - Invalid NID/BRN number length can be  NID(10, 13), / BRN(17) and in English numbers only`}`,
    validate: value => {
        // Remove non-digit characters just in case
        const numericValue = String(value).replace(/\D/g, '');
        const len = numericValue.length;

        // Valid lengths: 10 (new NID), 13 (old NID), 14-17 (BRN)
        if (len === 10 || len === 13 || (len > 13 && len <= 17)) {
        return true;
        }

        return false;
    }
    });

    Validator.extend('year_session', {
      getMessage: field => `${validationAttributes[field]} must be in a valid session format (YEAR-YEAR) and the second year should be equal to or greater than the first year (e.g., ${new Date().getFullYear()}-${new Date().getFullYear()+1}) in English numbers only`,
      validate(value) {
        // Match YYYY-YYYY
        if (!/^\d{4}-\d{4}$/.test(value)) {
          return false
        }

        const [start, end] = value.split('-').map(Number)

        // Logical check: second year must be equal or greater than first year
        return end >= start
      }
  });

    

  
}
